import Mapinfo from "./Mapinfo";

export default Mapinfo;
